<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/7OkiPm/tc-custom/9781250128041.jpg?1712900706482" alt="This image is the cover for the book Perfect Liar"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Perfect Liar
      </h1>
      <p class="bookDescription body article font2">
        <p><b>"A taut, well-written thriller...The pace is crisp, the surprises keep coming, and there are two big ones that readers are unlikely to see coming." - <i>Associated Press</i><br/><br/>A seemingly perfect marriage is threatened by the deadly secrets husband and wife keep from each other.<br/><br/></b>Susannah, a young widow and single mother, has remarried well: to Max, a charismatic artist and popular speaker whose career took her and her fifteen-year-old son out of New York City and to a quiet Vermont university town. Strong-willed and attractive, Susannah expects that her life is perfectly in place again. Then one quiet morning she finds a note on her door: I KNOW WHO YOU ARE. <br/><br/>Max dismisses the note as a prank. But days after a neighborhood couple comes to dinner, the husband mysteriously dies in a tragic accident while on a run with Max. Soon thereafter, a second note appears on their door: DID YOU GET AWAY WITH IT?<br/><br/>Both Susannah and Max are keeping secrets from the world and from each other—secrets that could destroy their family and everything they have built. Thomas Christopher Greene's <i>The Perfect Liar</i> is a thrilling novel told through the alternating perspectives of Susannah and Max with a shocking climax that no one will expect, from the bestselling author of <i>The Headmaster’s Wife.</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Thomas Christopher Greene
      </h2>
      
      <p class="authorDescription body article">THOMAS CHRISTOPHER GREENE is the author of five previous novels: <I>Mirror Lake; I'll Never Be Long Gone; Envious Moon; The Headmaster's Wife;</I> and <I>If I Forget You.</I> His fiction has been translated into 13 languages. In 2008, Tom founded Vermont College of Fine Arts, a top graduate fine arts college, making him the youngest college president in the country at the time. He lives and works in Vermont.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a1412ca6